import ua from './ua.js'
import { format } from 'date-fns'
import { subscribeFirefox } from '@pt/utils/subscribe'

/**
 * 参考文档：https://confluence.mobvista.com/pages/viewpage.action?pageId=89806741
 */

// 是否是firefox浏览器
export const isFirefoxBrowser = () => {
  return ua.isFirefox()
}

// 是否是Safari浏览器
export const isSafariBrowser = () => {
  return ua.isSafari()
}

// 判断当前是否是firefox用户
export const isUserFirefox = () => {
  if (isFirefoxBrowser() || isSafariBrowser()) {
    // 判断 localStorage中userFirefox,当天只展示一次
    const userFirefox = localStorage.getItem('userFirefox')
    if (
      userFirefox === null ||
      (userFirefox !== null && userFirefox !== format(new Date(), 'YYYY-MM-DD'))
    ) {
      // 不存在userFirefox则设置当天日期
      localStorage.setItem('userFirefox', format(new Date(), 'YYYY-MM-DD'))
      subscribeFirefox()
    }
  }
}

export const isMobileDevice = () => {
  return ua.checkIsMobile()
}
